import { render, staticRenderFns } from "./CartChanges.vue?vue&type=template&id=731b5ef4&"
import script from "./CartChanges.vue?vue&type=script&lang=js&"
export * from "./CartChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('731b5ef4')) {
      api.createRecord('731b5ef4', component.options)
    } else {
      api.reload('731b5ef4', component.options)
    }
    module.hot.accept("./CartChanges.vue?vue&type=template&id=731b5ef4&", function () {
      api.rerender('731b5ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/CartChanges.vue"
export default component.exports